var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SCardsProduct',{attrs:{"title":_vm.getTitle,"lead":_vm.getLead,"link":_vm.getLink,"cards":_vm.getCards}})
}
var staticRenderFns = []

export { render, staticRenderFns }